import React, { Fragment, useState, useEffect } from "react";
import { Card, Modal, Button, Form, Spinner } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import Snackbars from "../../../utils/Snackbars";
import useRequests from "../../../utils/useRequests";
import DataTable from "react-data-table-component";


const StaffList = () => {
  const location = useLocation();
  const { getRequest, deleteRequest, putRequest } = useRequests();
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState(""); // "enable", "disable", "delete"
  const [selectedStaff, setSelectedStaff] = useState(null);
  const [staffs, setStaffs] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');

 

  const [AlertData, setAlertData] = React.useState({
    variant: '',
    message: '',
  });

  const resetAlertData = () => {
    setTimeout(() => {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: '',
        message: '',
      }));
    }, process.env.REACT_APP_ALERT_AUTO_CLOSE);
  };

  const [loading, setLoading] = useState(true);

  const fetchStaffs = async () => {
    const response = await getRequest("staff-list"); // Replace "staffs" with the appropriate API endpoint
    if (response && response.code === 200) {
      setStaffs(response.data);
    } else {
      console.error("Failed to fetch staffs:", response.message);
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'error',
        message: 'Failed to fetch staffs',
      }));
    }
    resetAlertData();
    setLoading(false);
  };

  useEffect(() => {
    fetchStaffs();
    if (location.state && typeof location.state.message !== 'undefined') {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: location.state.status,
        message: location.state.message,
      }));
      resetAlertData();
      setLoading(false);
    }
  }, []);

  // Filter staffs based on the search query
  const filteredStaffs = staffs.filter((staff) => {
    const email = `${staff.email}`.toLowerCase();
    const status = `${staff.status}`.toLowerCase();
    const fullName = `${staff.first_name} ${staff.last_name}`.toLowerCase();
    // const query = {fullName, email};
    // return query.includes(searchQuery.toLowerCase());
    const searchLower = searchQuery.toLowerCase();
  
    return email.includes(searchLower) || fullName.includes(searchLower) || status.includes(searchQuery);
  });

  const handleOpenModal = (staff, type) => {
    setSelectedStaff(staff);
    setModalType(type);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setModalType("");
    setSelectedStaff(null);
  };

  const [isProcessing, setIsProcessing] = useState(false);
  const handleConfirmAction = async () => {
    if (selectedStaff) {
    setIsProcessing(true);
      if (modalType === "delete") {
        const response = await deleteRequest(`staff-delete/${selectedStaff.s_id}`);
        if (response && response.code === 200) {
          const updatedStaffs = staffs.filter((staff) => staff.s_id !== selectedStaff.s_id);
          setStaffs(updatedStaffs);
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'success',
            message: 'Staff deleted successfully!',
          }));
          resetAlertData();
        } else {
          console.error("Failed to delete staff:", response?.message);
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'error',
            message: 'Failed to delete staff',
          }));
          resetAlertData();
        }
      } else if (modalType === "enable" || modalType === "disable") {
        const newStatus = modalType === "enable" ? "Enable" : "Disable";
        try {
          const jsonpar = JSON.stringify({status: newStatus});
          const response = await putRequest(`staff-status/${selectedStaff.s_id}`, jsonpar);
          if (response && response.code === 200) {
            const updatedStaffs = staffs.map((staff) =>
              staff.s_id === selectedStaff.s_id ? { ...staff, status: newStatus } : staff
            );
            setStaffs(updatedStaffs);
            setAlertData((AlertData) => ({
              ...AlertData,
              variant: 'success',
              message: `Staff ${newStatus}d successfully`,
            }));
            resetAlertData();
          } else {
            console.error("Failed to update status:", response?.message);
            setAlertData((AlertData) => ({
              ...AlertData,
              variant: 'error',
              message: `Failed to ${newStatus} staff.`,
            }));
            resetAlertData();
          }
        } catch (error) {
          console.error("Error updating status:", error);
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'error',
            message: 'Error updating status',
          }));
          resetAlertData();
        }
      }
      setIsProcessing(false);
      handleCloseModal();
    }
  };

  const columns = [
    {
      name: "Full Name",
      selector: (row) => `${row.first_name} ${row.last_name}`,
      sortable: true,
    },
    {
      name: "Email ID",
      selector: (row) => row.email,
      sortable: true,
    },
    {
      name: "Status",
      cell: (row) => (
        <button
          onClick={() =>
            handleOpenModal(row, row.status === "Enable" ? "disable" : "enable")
          }
          className={`btn ${
            row.status === "Enable" ? "btn-success" : "btn-danger"
          } btn-xxs`}
        >
          {row.status === "Enable" ? "Enable" : "Disable"}
        </button>
      ),
      center: true,
      width: "150px",
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="text-center">
          <Link className="btn btn-primary btn-xxs me-2" to={`/staff-edit/${row.s_id}`} title="Edit Staff">
            <i className="fa-regular fa-pen-to-square"></i>
          </Link>
          <button className="btn btn-danger btn-xxs me-2" onClick={() => handleOpenModal(row, "delete")}  title="Delete Staff">
            <i className="fa-solid fa-trash"></i>
          </button>
        </div>
      ),
      center: true,
      width: "220px",
    },
  ];

  const customStyles = {
    header: {
      style: {
        minHeight: "56px",
      },
    },
    headCells: {
      style: {
        color: "#341439",
        fontSize: "17px",
        fontWeight: "600",
        paddingLeft: "8px", // Adjust padding
        paddingRight: "8px",
      },
    },
    cells: {
      style: {
        fontSize: "16px",
        padding: "12px 9px",
        color: "#7E7E7E",
      },
    },
    pagination: {
      style: {
        fontSize: "16px",
      },
    },
  };

  // if (loading) return <p>Fetching data...</p>;

  return (
    <Fragment>
      {AlertData.message !== "" ? (
          <Snackbars variant={AlertData.variant} message={AlertData.message} />
        ) : (
          ""
        )}
      <div className='d-sm-flex d-block justify-content-between align-items-center mb-4'>
        <h2 className='text-black font-w600 mb-0'>Staff Management</h2>
        <Link
          to='/staff-add'
          type='button'
          className='btn btn-rounded btn-primary'
        >
          Add Staff
        </Link>
      </div>

      {/* Search input */}
      <div className='mb-4 d-sm-flex d-block justify-content-end'>
      <div style={{ position: "relative", width: "18rem" }}>
  <Form.Control
    type="text"
    placeholder="Search..."
    value={searchQuery}
    onChange={(e) => setSearchQuery(e.target.value)}
    style={{
      width: "100%",
      fontSize: "18px",
      fontWeight: 500,
      paddingRight: "2rem",
      borderRadius:'0.625rem',
      height:'3.2rem' // Add padding to ensure the icon doesn't overlap text
    }}
  />
  <i
    className="fa fa-search"
    style={{
      position: "absolute",
      right: "10px", // Distance from the right edge of the input
      top: "50%",
      transform: "translateY(-50%)", // Center vertically
      color: "#6c757d", // Optional: color for the icon
      pointerEvents: "none", // Makes sure clicks pass through to the input
    }}
  ></i>
</div>
      </div>

      <Card>
        <Card.Body>
          {loading ? (
                <div className='text-center'>
                  <Spinner animation='border' />
                  <p>Loading settings...</p>
                </div>) : 
          (<DataTable
            columns={columns}
            data={filteredStaffs} // Use filtered data
            customStyles={customStyles}
            pagination
            highlightOnHover
            responsive
          />)}
        </Card.Body>
      </Card>

      {/* Enable/Disable/Delete Modal */}
      <Modal show={showModal} onHide={handleCloseModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            {modalType === "enable" && "Enable Staff"}
            {modalType === "disable" && "Disable Staff"}
            {modalType === "delete" && "Delete Staff"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {modalType === "delete" ? (
            <>
              Are you sure you want to delete the staff{" "}
              <strong>
                {selectedStaff?.first_name} {selectedStaff?.last_name}
              </strong>
              ? This action cannot be undone.
            </>
          ) : (
            `Are you sure you want to ${modalType} the staff ${selectedStaff?.first_name} ${selectedStaff?.last_name}?`
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant='light' onClick={handleCloseModal}>
            Cancel
          </Button>
          <Button
            className={`btn btn-${
              modalType === "enable"
                ? "success"
                : modalType === "disable"
                ? "danger"
                : "danger"
            }`}
            onClick={handleConfirmAction}
            disabled={isProcessing}
          >
            {modalType === "enable" && "Enable"}
            {modalType === "disable" && "Disable"}
            {modalType === "delete" && "Delete"}
          </Button>
        </Modal.Footer>
      </Modal>
    </Fragment>
  );
};

export default StaffList;
